import React, { useState } from "react";
import "./FirstSection.css";
import { Link } from "react-router-dom";
import heroBg from "../../assets/parallax-bg-01.jpg";
import heroBg2 from "../../assets/parallax-bg-04.jpg";
import aboutBg from "../../assets/parallax-bg-02.jpg";

import about1 from "../../assets/about-01.jpg";
import about2 from "../../assets/about-02.jpg";
import intuAbout1 from "../../assets/parallax-bg-02.jpg";
import intuAbout2 from "../../assets/parallax-bg-02.jpg";
const FirstSection = () => {
  const [company, setCompany] = useState("fidin");

const companyData = {
  fidin: {
    name: "FIDIN VENTURES PVT. LTD.",
    tagline: "Building India's Future",
    heroBg: heroBg,
    overlay: "rgba(0,0,0,0.60)",
    btnColor: "#ff6b35",
    btnText: "DISCOVER MORE",
    about: [
  {
    image: about1,
    title: "FIDIN Construction",
    description:
      "It is a leading construction company with over 15 years of experience. We specialize in residential, commercial and industrial projects with modern technology and timely completion."
  },
  {
    image: about2,
    title: "FIDIN Ventures",
    description:
      "FIDIN Ventures is an engineering driven infrastructure company delivering renewable energy, power transmission and industrial EPC solutions across India."
  }
],
    switchText: "INTUVELIXIS"
  },

  intuvelixis: {
    name: "INTUVELIXIS",
    tagline: "Transforming Businesses Through SAP & AI",
    heroBg: heroBg2, // we'll replace later
    overlay: "rgba(20,20,40,0.35)",
    btnColor: "#5a4dff",
    btnText: "EXPLORE SOLUTIONS",
    about: [
  {
    image: intuAbout1,
    title: "SAP Consulting",
    description:
      "Helping enterprises modernize business processes through SAP implementation, migration and optimization."
  },
  {
    image: intuAbout2,
    title: "Digital Transformation",
    description:
      "Delivering AI, cloud, analytics and enterprise solutions that accelerate digital transformation."
  }
],
    switchText: "FIDIN"
  }
};

const current = companyData[company];
  return (
    <>

<section className="first-section">

  <div
    className="first-section-bg"
    style={{
      backgroundImage: `url(${current.heroBg})`
    }}
  ></div>

  <div
    className="first-section-overlay"
    style={{
      background: current.overlay
    }}
  ></div>

  <div className="first-section-content">

    <div className="company-tag">
      CURRENTLY VIEWING
    </div>

    <h1>{current.name}</h1>

    <p>{current.tagline}</p>

    <div className="hero-buttons">

      <Link
        to="/about"
        className="discover-btn"
        style={{
          background: current.btnColor
        }}
      >
        {current.btnText}
      </Link>

    </div>

  </div>

</section>

      {/* ABOUT SECTION */}

      <section
        className="about-section"
        style={{
          backgroundImage: `
          linear-gradient(rgba(26,26,26,0.92), rgba(26,26,26,0.92)),
          url(${aboutBg})
          `
        }}
      >

<div className="about-container">

  {current.about.map((item, index) => (

    <div className="about-box" key={index}>

      <img src={item.image} alt={item.title} />

      <h3>{item.title}</h3>

      <p>{item.description}</p>

    </div>

  ))}

</div>

      </section>

      {/* BUTTON SECTION */}

      <section className="button-section">

<Link to="/projects" className="primary-btn">
  Explore Our Projects
</Link>

<Link to="/founder" className="secondary-btn">
  Partner With Us
</Link>

      </section>

    </>
  );
};

export default FirstSection;